import { KnowledgeDocumentService } from './knowledgeDocumentService';
import { AxiosResponse } from 'axios';
import { KnowledgeDocumentDto } from 'src/types/knowledgeDocument';

export interface ApiKnowledgeDocumentService {
    getKnowledgeDocuments(urlParams: string): Promise<AxiosResponse>;
    getAllKnowledgeDocuments(): Promise<AxiosResponse>;
    deleteKnowledgeDocuments(ids: string[]): Promise<AxiosResponse>;
    getKnowledgeDocumentById(id: string): Promise<AxiosResponse>;
    uploadDocument(documentId: string, data: FormData): Promise<AxiosResponse>;
    deleteUploadedDocument(documentId: string, fileName: string): Promise<AxiosResponse>;
    createKnowledgeDocument(data: KnowledgeDocumentDto): Promise<AxiosResponse>;
    updateKnowledgeDocument(id: string, data: KnowledgeDocumentDto): Promise<AxiosResponse>;
}

export const knowledgeDocumentService = new KnowledgeDocumentService();
